import StoreState from '../storeState';

/*
 * Shared selectors for scene
 */
export const activeSceneSelector = (state: StoreState) => state.scene.scenes.activeScene;
export const activeSceneEntitySelector = (state: StoreState) => state.scene.scenes.activeScene.entity;
export const activeSceneStatusSelector = (state: StoreState) => state.scene.scenes.activeScene.status;
export const allScenesSelector = (state: StoreState) => state.scene.scenes.scenes;